var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
var useTypedSelector = useSelector;
var useFormatters = function () {
    var intl = useIntl();
    var event = useTypedSelector(function (store) { return store.events; }).event;
    var isCurrentYear = function (value) {
        return value ? new Date(value).getFullYear() === new Date().getFullYear() : false;
    };
    var formatDate = function (value, options) {
        return (_jsx("span", __assign({ title: intl.formatDate(value, options !== null && options !== void 0 ? options : {
                month: "long",
                day: "numeric",
                year: "numeric",
                weekday: "long",
            }) }, { children: intl.formatDate(value, options !== null && options !== void 0 ? options : {
                month: "long",
                day: "numeric",
                year: isCurrentYear(value) ? undefined : "numeric",
                weekday: "long",
            }) })));
    };
    var formatShortDate = function (value, options) {
        return intl.formatDate(value, options !== null && options !== void 0 ? options : {
            month: "2-digit",
            day: "2-digit",
            year: isCurrentYear(value) ? undefined : "2-digit",
        });
    };
    var formatTime = function (value, options) {
        return intl.formatTime(value, options);
    };
    var formatCurrency = function (value, options) {
        var _a;
        return intl.formatNumber(value, options !== null && options !== void 0 ? options : {
            style: "currency",
            currency: (_a = event === null || event === void 0 ? void 0 : event.currency) !== null && _a !== void 0 ? _a : "USD",
        });
    };
    var formatCurrencyRounded = function (value, options) {
        var _a;
        if (value <= 1) {
            return formatCurrency(value, options);
        }
        var parts = intl.formatNumberToParts(Math.ceil(value), options !== null && options !== void 0 ? options : {
            style: "currency",
            currency: (_a = event === null || event === void 0 ? void 0 : event.currency) !== null && _a !== void 0 ? _a : "USD",
        });
        var decimalIndex = parts.findIndex(function (p) { return p.type === "decimal"; });
        if (decimalIndex) {
            return parts
                .slice(0, decimalIndex)
                .map(function (p) { return p.value; })
                .join("");
        }
        return parts.map(function (p) { return p.value; }).join("");
    };
    return { formatDate: formatDate, formatTime: formatTime, formatShortDate: formatShortDate, formatCurrency: formatCurrency, formatCurrencyRounded: formatCurrencyRounded };
};
export default useFormatters;
